import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
  Inject,
  OnInit,
  Optional,
} from '@angular/core';
import { NgFor, NgIf, NgSwitch, NgSwitchCase } from '@angular/common';

import { Breadcrumb } from './breadcrumbs.types';
import { BreadcrumbsService } from './breadcrumbs.service';

@Component({
  selector: 'iss-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: [ './breadcrumbs.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  exportAs: 'issBreadcrumbs',
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    NgSwitch,
    NgSwitchCase,
    RouterLink,
    TranslateModule,
  ],
})
export class BreadcrumbsComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  public breadcrumbs: readonly Breadcrumb[] = [];

  public constructor(
    @Optional() @Inject(BreadcrumbsService)
    private readonly breadcrumbsService: BreadcrumbsService | undefined,
    private readonly changeDetectorRef: ChangeDetectorRef,
  ) {}

  public get visible(): boolean {
    return Boolean(this.breadcrumbsService) && this.breadcrumbs.length > 1;
  }

  public ngOnInit(): void {
    if (this.breadcrumbsService) {
      this.breadcrumbsService.breadcrumbs$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(breadcrumbs => {
        this.breadcrumbs = breadcrumbs;
        this.changeDetectorRef.markForCheck();
      });
    }
  }
}
